import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Grid, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { Icon } from '../../../components';

const AccountSettings = ({
  isDropdownOpen,
  match,
  onSelectTab,
  tabs,
  title,
  toggleDropdownOpen,
  breadcrumb,
  ...props
}) => (
    <div id='account-settings'>
      <Grid>
        <section id='title--main'>
          {breadcrumb}
          <h1>
            <Icon icon='settings' /> {title}
          </h1>
        </section>
        <section id='nav--tabs'>
          <Tabs
            id='settings-screen'
            className={classNames('tab-zone', { opened: isDropdownOpen })}
            activeKey={match.params.tab}
            onSelect={onSelectTab}>
            {
              fp.flow(
                fp.filter((tab) => fp.getOr(fp.stubTrue)('shouldDisplay')(tab)(props)),
                fp.map(({ content, path, title }, index) => (
                  <Tab key={fp.camelCase(title)} eventKey={path}
                    title={[
                      <span key={0}>{title}</span>,
                      <span key={1} className='activeArrow' onClick={toggleDropdownOpen}>
                        <i className='icon-chevron-down-large' />
                      </span>
                    ]}>
                    {
                      match.params.tab === path ?
                        <section className={classNames('content', path)}>
                          {content}
                        </section> :
                        null
                    }
                  </Tab>
                ))
              )(tabs)
            }
          </Tabs>
        </section>
      </Grid>
    </div>
  );

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onTabSelect: bindActionCreators(push, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    isDropdownOpen: false
  }, {
      toggleDropdownOpen: ({
        isDropdownOpen
      }) => (e) => {
        e.preventDefault();
        e.stopPropagation();

        return {
          isDropdownOpen: !isDropdownOpen
        };
      }
    }
  ),
  withHandlers({
    onSelectTab: ({
      match: {
        params: {
          tab
        }
      },
      onTabSelect,
      routes,
      tabs
    }) => (key) =>
        !fp.eq(tab)(key) &&
        onTabSelect(routes(key))
  })
)(AccountSettings);



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/account-settings.js